import { type TestId } from '@repo/test-id';
import { formatDurationTime } from '@repo/date-time';

interface Props {
  parkDuration: number;
  testId: TestId;
}

export default function TimeContractEndTimeDisplay({ parkDuration, testId }: Props) {
  return (
    <div className="flex items-center justify-center">
      <div className="bg-secondary-soft border-stroke-base inline-flex h-16 flex-col items-center justify-center rounded-xl border px-5 py-1.5">
        <div className="text-heading justify-start text-4xl leading-[54px] font-medium" data-testid={testId}>
          {formatDurationTime(parkDuration)}
        </div>
      </div>
    </div>
  );
}
